import { ArrowThroughHeartFill, BoxFill, Fire, HeartFill } from 'react-bootstrap-icons';

const messages = [
    { text: "¡Desde Octubre hasta Diciembre!", icon: HeartFill },
    { text: "10%, 15% y hasta el 20% descuento", icon: ArrowThroughHeartFill },
    { text: "Aplica desde 1 unidad", icon: Fire },
    { text: "¡Envios a todo Colombia!", icon: BoxFill },

];

const Marquee = () => {
    return (
        <div className="marquee-container" >
            <div className="marquee-content my-2">
                {messages.map((msg, index) => {
                    const Icon = msg.icon;
                    return (
                        <span key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <Icon size={20} />
                            {msg.text}
                        </span>
                    );
                })}
                {/* Repetir los mensajes */}
                {messages.map((msg, index) => {
                    const Icon = msg.icon;
                    return (
                        <span key={index + messages.length} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <Icon size={20} />
                            {msg.text}
                        </span>
                    );
                })}
            </div>
        </div>
    );
};

export default Marquee;